import React from 'react';
import { Button, Modal, message, Space } from 'antd';
import { useNavigate } from 'react-router-dom';

export default function Settings({ onClearData, onExportData, loggedInUser }) {
  const navigate = useNavigate();

  const handleClear = () => {
    Modal.confirm({
      title: '确认清除本地数据并登出？',
      content: '此操作会清除本地存储的文章、用户与登录信息，无法恢复。是否继续？',
      okText: '清除并登出',
      cancelText: '取消',
      onOk() {
        if (onClearData) onClearData();
        message.info('已清除本地数据');
        navigate('/');
      },
    });
  };

  const handleExport = () => {
    try {
      if (onExportData) {
        onExportData();
        message.success('已导出本地数据');
      } else {
        message.error('导出功能不可用');
      }
    } catch (e) {
      console.error('导出失败', e);
      message.error('导出失败');
    }
  };

  return (
    <div className="page-container">
      <h2>设置</h2>
      <Space orientation="vertical">
        <div>
          <strong>导出 / 备份</strong>
          <div style={{ marginTop: 8 }}>
            <Button type="primary" onClick={handleExport}>导出本地数据</Button>
          </div>
        </div>

        <div>
          <strong>清除数据</strong>
          <div style={{ marginTop: 8 }}>
            <Button danger onClick={handleClear}>清除本地数据并登出</Button>
          </div>
        </div>

        <div>
          <strong>当前登录</strong>
          <div style={{ marginTop: 8 }}>{loggedInUser ? loggedInUser.name : '未登录'}</div>
        </div>
      </Space>
    </div>
  );
}
